import * as React from "react";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean;
  width?: string | number;
  height?: string | number;
  variant?: "primary" | "primaryReverse" | "white" | "reset" | "search" | "etc" | "add" | "deepGreen";
  size?: "sm" | "md" | "lg";
  leftIcon?: string; // 이미지 URL 또는 경로
  leftIconSize?: number; // 아이콘 크기 (기본값: 16)
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      width,
      height,
      variant = "primary",
      size = "md",
      asChild = false,
      style,
      leftIcon,
      leftIconSize = 16,
      children,
      ...props
    },
    ref
  ) => {
    // 기본 스타일
    const baseStyles =
      "inline-flex items-center justify-center rounded-lg font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";

    // variant 스타일
    const variantStyles = {
      primary: "bg-[#83C41C] text-white hover:bg-[#83C41C]/90 cursor-pointer min-w-20 py-2",
      primaryReverse:
        "bg-[#FFFFFF] text-[#83C41C] font-bold hover:bg-[#F6F6F6]/90 cursor-pointer min-w-20 py-2 border border-[#83C41C]",
      white:
        "bg-[#FFF] text-[#333333] hover:bg-[#F6F6F6]/90 rounded-lg text-base cursor-pointer border border-[#CCCCCC] px-2 py-2 min-w-20",
      reset:
        "bg-[#FFF] text-[#333333] hover:bg-[#F6F6F6]/90 rounded-lg text-base cursor-pointer border border-[#CCCCCC] px-2 py-2 min-w-20",
      search: "bg-[#4B5563] text-[#FFF] hover:bg-[#4B5563]/90 rounded-lg text-base cursor-pointer px-2 py-2 min-w-20",
      etc: "bg-[#FFFFFF] font-normal text-[#333] hover:bg-[#FFFFFF]/90 rounded-lg text-base cursor-pointer border border-[#CCCCCC] min-w-20 py-2",
      add: "bg-[#FFFFFF] text-[#333333] hover:bg-[#F6F6F6]/90 cursor-pointer rounded-lg min-w-20 border border-[#CCCCCC]  px-2 py-1 text-sm",
      deepGreen: "bg-[#42630F] text-white hover:bg-[#42630F]/90 cursor-pointer min-w-20 py-2",
    };

    // 스타일 조합
    const combinedClassName = `${baseStyles} ${variantStyles[variant]} ${className || ""}`;

    // 인라인 스타일 생성
    const inlineStyles = {
      ...style,
      ...(width && { width }),
      ...(height && { height }),
    };

    return (
      <button id={props.id} className={combinedClassName} style={inlineStyles} ref={ref} {...props}>
        {leftIcon && <img src={leftIcon} alt="icon" width={leftIconSize} height={leftIconSize} />}
        {variant === "reset" && <img src="/icons/reset.svg" alt="icon" width={20} height={20} className="mr-2" />}
        {variant === "search" && <img src="/icons/search.svg" alt="icon" width={20} height={20} className="mr-2" />}
        {variant === "add" && <img src="/icons/addIcon.svg" alt="icon" width={16} height={16} className="mr-2" />}
        {children}
      </button>
    );
  }
);
Button.displayName = "Button";

export { Button };
